module.exports = __webpack_public_path__ + "images/logo.14de0c.svg";